import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import { PageLoading } from "@/components/shared/loading";

const InvoiceGateReviewPage = lazy(() => import("@/features/invoice-gate/pages/invoice-gate-review"));

export type InvoiceGateReviewSearch = {
  /** Batch to review - in the URL so the page survives refresh and deep links. */
  batchId?: string;
};

export const Route = createFileRoute("/(app)/dashboard/invoice-gate/review")({
  validateSearch: (search: Record<string, unknown>): InvoiceGateReviewSearch => ({
    batchId: typeof search.batchId === "string" && search.batchId ? search.batchId : undefined,
  }),
  component: () => (
    <Suspense fallback={<PageLoading />}>
      <InvoiceGateReviewPage />
    </Suspense>
  ),
});
